import Common_Contact_Form from "./common_contact_form";
import Footer from "./Footer";
import Header from "./Header";
import React from "react";
import SEO from "./SeoHelmet";
import metaConfig from "./SeoComponent";
import { useLocation } from "react-router-dom";

const SponsorshipPartner = () => {
  const location = useLocation(); // Get the current location (path)
  const meta = metaConfig.sponsershipparner;

  return (
    <div>
      <SEO {...meta} />

      <div class="container-fluid position-relative p-0">
        <div class="w-100 me-3 top_head">
          <div class="top_head align-items-center"></div>
        </div>
        <Header />
      </div>

      <div class="container-fluid Finance_sponser bg-breadcrumb">
        <div class="container text-center py-5" style={{ maxWidth: "900px" }}>
          <ol
            class="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown"
            data-wow-delay="0.3s"
          ></ol>
          <h4
            class="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            Building a Better Future Together
          </h4>
        </div>
      </div>
      <div
        class="modal fade"
        id="searchModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-fullscreen">
          <div class="modal-content rounded-0">
            <div class="col-lg-12 m-auto modal-header justify-content-lg-end">
              <button
                type="button"
                class="btn-close justify-content-lg-end text-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="col-lg-9 m-auto modal-header align-items-center text-center">
              <h4
                class="modal-title mb-0 m-auto text-white"
                id="exampleModalLabel"
              >
                Search by keyword
              </h4>
            </div>
            <div class="modal-body align-items-center">
              <div class="input-group w-75 mx-auto d-flex">
                <input
                  type="search"
                  class="form-control p-3"
                  placeholder="keywords"
                  aria-describedby="search-icon-1"
                />
                <span
                  id="search-icon-1"
                  class="input-group-text btn border p-3"
                >
                  <i class="fa fa-search text-white"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid innercontain ktig_services_page finance_details_1 overflow-hidden pt-5">
        <div class="container">
          <div class="row col-xl-10 pb-0 m-auto g-5">
            <div
              class="text-center mt-0 mx-auto wow fadeInUp"
              data-wow-delay="0.2s"
            >
              <h1 class="display-3 text-capitalize text-white">
                Sponsorship Partner
              </h1>
            </div>

            <div
              className="page_details_inner wow fadeInUp"
              data-wow-delay="0.2s"
            >
              <p className="text-white text-left">
                Resource sponsors play a crucial role in KTIG’s efforts to
                achieve sustainable growth and drive impactful initiatives.
                These sponsors provide essential resources, whether financial,
                technological, or in-kind, that enable KTIG to execute
                innovative projects and expand its reach. Their support helps
                fuel KTIG’s initiatives, ensuring that we can continue to
                develop cutting-edge solutions, foster innovation, and make a
                positive impact in the industries we serve.
              </p>
              <p className="text-white text-left">
                By partnering with resource sponsors, KTIG can access vital
                tools, technologies, and infrastructure that enhance our
                capabilities and strengthen our operations. These sponsors
                contribute to the success of our projects by offering not only
                resources but also strategic insights, allowing us to maximize
                efficiency and achieve optimal outcomes. At KTIG, we carefully
                select resource sponsors who share our values and vision for the
                future. We believe that successful partnerships are built on
                trust, transparency, and mutual benefit, and we work closely
                with our sponsors to ensure a lasting and meaningful
                collaboration.
              </p>
              <p className="text-white text-left">
                Through the support of our resource sponsors, KTIG can continue
                to break new ground, create innovative solutions, and build a
                brighter future for businesses and communities alike. Together,
                we are shaping a path toward long-term success and sustainable
                development.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid overflow-hidden pb-5 p-0">
        <Common_Contact_Form />
      </div>

      <Footer />

      <a
        href="#"
        class="btn btn-secondary btn-lg-square rounded-circle back-to-top"
      >
        <i class="fa fa-arrow-up"></i>
      </a>
    </div>
  );
};

export default SponsorshipPartner;
